const MAX_MINOR_UNITS = 2_147_483_647;

/**
 * Reads what a person typed into a money field ("1,200.50") as integer minor units. String arithmetic only: no
 * float ever holds money. Null for anything that is not a positive amount with at most two decimals.
 */
export function parseMoneyInput(text: string): number | null {
  const m = /^(\d+)(?:\.(\d{1,2}))?$/.exec(text.trim().replaceAll(',', ''));
  if (!m) return null;
  const whole = m[1] as string;
  if (whole.length > 9) return null;
  const cents = Number(whole) * 100 + Number((m[2] ?? '').padEnd(2, '0'));
  return cents >= 1 && cents <= MAX_MINOR_UNITS ? cents : null;
}

/** Integer minor units as the plain text a money field shows ("500.00"). Display elsewhere uses `useFormat()`. */
export function minorUnitsToInput(minorUnits: number): string {
  const whole = Math.trunc(minorUnits / 100);
  return `${whole}.${String(minorUnits % 100).padStart(2, '0')}`;
}
